import Page from '../../../shared/components/Page/Page';
import React, { useState, useEffect } from 'react';
import {
  Form,
  Input,
  Button,
  Table,
  message,
  Typography,
  Drawer,
  Space,
  Tag,
  DatePicker,
  Select
} from 'antd';
import { createDeposit } from '../api';
import { getDepositHistory } from '../api';
import { PlusOutlined, SearchOutlined } from '@ant-design/icons';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAdd } from "@fortawesome/free-solid-svg-icons";
import dayjs from 'dayjs';
const { Text } = Typography;
const { RangePicker } = DatePicker;
const Deposit = () => {
  const [form] = Form.useForm();
  const [searchForm] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [depositHistory, setDepositHistory] = useState([]);
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [searchParams, setSearchParams] = useState({});
  const [tableParams, setTableParams] = useState({
    pagination: {
      current: 1,
      pageSize: 10,
      total: 0,
    },
    search: {
      createdAt: [dayjs().startOf('day'), dayjs().endOf('day')]
    }
  });
  const [sorter, setSorter] = useState({
    field: 'created_at',
    order: 'descend'
  });
  const columns = [
    {
      title: 'ID',
      dataIndex: 'depositId',
      key: 'depositId',
      sorter: true,
      align: 'center'
    },
    {
      title: 'Thời gian',
      dataIndex: 'createdAt',
      key: 'createdAt',
      sorter: true,
      align: 'center',
      render: (text) => (
        <Text style={{ whiteSpace: 'nowrap' }}>
          {new Date(text).toLocaleString()}
        </Text>
      ),
    },
    {
      title: 'Số tiền',
      dataIndex: 'amount',
      key: 'amount',
      sorter: true,
      align: 'center',
      render: (amount) => (
        <Text strong style={{ color: '#1890ff' }}>
          {amount.toLocaleString()} VND
        </Text>
      ),
    },
    {
      title: 'Trạng thái',
      dataIndex: 'statusCode',
      key: 'statusCode',
      sorter: true,
      align: 'center',
      render: (statusCode) => {
        const statusConfig = {
          1: { color: 'success', text: 'Đã duyệt' },
          2: { color: 'error', text: 'Từ chối' },
          0: { color: 'warning', text: 'Đang xử lý' }
        };
        const config = statusConfig[statusCode] || { color: 'default', text: 'Không xác định' };
        return <Tag color={config.color}>{config.text}</Tag>;
      },
    },
    {
      title: 'Ghi chú',
      dataIndex: 'note',
      key: 'note',
      align: 'center',
      render: (note) => (
        <Text ellipsis={{ tooltip: note }}>
          {note || '-'}
        </Text>
      ),
    }
  ];
  const statusOptions = [
    { label: 'Tất cả', value: '' },
    { label: 'Đang xử lý', value: 0 },
    { label: 'Đã duyệt', value: 1 },
    { label: 'Từ chối', value: 2 }
  ];
  const formatNumber = (value) => {
    if (!value) return '';
    const number = value.toString().replace(/,/g, '');
    return number.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  };
  const parseNumber = (value) => {
    return value.toString().replace(/,/g, '');
  };
  const handleAmountChange = (e) => {
    const { value } = e.target;
    const reg = /^[0-9,]*$/;
    if (reg.test(value) || value === '') {
      const numericValue = parseNumber(value);
      form.setFieldValue('amount', formatNumber(numericValue));
    }
  };
  const onFinish = async (values) => {
    try {
      setLoading(true);
      const response = await createDeposit(values);
      if (response.success) {
        message.success('Yêu cầu nạp tiền đã được gửi');
        form.resetFields();
        fetchDepositHistory();
        setDrawerVisible(false);
      } else {
        message.error(response.message || 'Có lỗi xảy ra. Vui lòng thử lại');
      }
    } catch (error) {
      message.error('Có lỗi xảy ra. Vui lòng thử lại');
    } finally {
      setLoading(false);
    }
  };
  const fetchDepositHistory = async (page = 1, pageSize = 10, currentSorter = sorter, searchValues = searchParams) => {
    try {
      setLoading(true);
      const params = {
        search: {
          ...searchValues
        },
        pagination: {
          current: page,
          pageSize: pageSize
        },
        sorter: {
          field: currentSorter.field,
          order: currentSorter.order
        }
      };
      
      const response = await getDepositHistory( params);
      if (response.success) {
        setDepositHistory(response.data.data);
        setTableParams({
          ...tableParams,
          pagination: {
            ...tableParams.pagination,
            total: response.data.total,
          },
        });
      } else {
        message.error('Không thể tải lịch sử nạp tiền');
      }
    } catch (error) {
      message.error('Không thể tải lịch sử nạp tiền');
    } finally {
      setLoading(false);
    }
  };
  const handleTableChange = (pagination, filters, sorter) => {
    const newSorterState = {
      field: sorter.field || 'created_at',
      order: sorter.order || 'descend'
    };
    setSorter(newSorterState);
    setTableParams({
      ...tableParams,
      pagination,
      filters,
      sorter: newSorterState,
    });
  };
  const handleSearch = (values) => {
    const searchValues = {};
    
    if (values.dateRange) {
      searchValues.createdAt = values.dateRange;
    }
    
    if (values.statusCode !== undefined && values.statusCode !== '') {
      searchValues.status = values.statusCode;
    }
    setSearchParams(searchValues);
    setTableParams({
      ...tableParams,
      search: searchValues,
      pagination: {
        ...tableParams.pagination,
        current: 1
      }
    });
  };
  const handleReset = () => {
    searchForm.resetFields();
    const emptySearchValues = {
      createdAt: [dayjs().startOf('day'), dayjs().endOf('day')]
    };
    setSearchParams(emptySearchValues);
    setTableParams({
      ...tableParams,
      search: emptySearchValues,
      pagination: {
        ...tableParams.pagination,
        current: 1
      }
    });
  };
  useEffect(() => {
    fetchDepositHistory(
      tableParams.pagination.current,
      tableParams.pagination.pageSize
    );
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    tableParams.pagination.current,
    tableParams.pagination.pageSize,
    tableParams.sorter,
    tableParams.search,
    // eslint-disable-next-line react-hooks/exhaustive-deps
    JSON.stringify(tableParams.filters),
  ]);
  return (
    <Page title="Nạp số dư">
      <div style={{
        padding: '24px',
        background: '#fff',
        borderRadius: '8px',
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.06)'
      }}>
        <div style={{
          marginBottom: '24px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}>
          <Button 
            type="primary" 
            ghost={true} 
            onClick={() => setDrawerVisible(true)}
            style={{
              height: '40px',
              padding: '0 20px',
              fontWeight: 500,
              display: 'flex',
              alignItems: 'center',
              gap: '8px'
            }}
          >
            <FontAwesomeIcon icon={faAdd} style={{ fontSize: '14px' }}/>
            Tạo yêu cầu nạp tiền
          </Button>
        </div>
        <div style={{
          marginBottom: '24px',
          padding: '16px',
          background: '#f7f9fc',
          borderRadius: '6px'
        }}>
          <Form
            form={searchForm}
            layout="horizontal"
            onFinish={handleSearch}
            initialValues={{
              dateRange: [dayjs().startOf('day'), dayjs().endOf('day')]
            }}
          >
            <Space wrap style={{ width: '100%', justifyContent: 'flex-start', gap: '16px' }}>
              <Form.Item name="statusCode" style={{ marginBottom: 0 }}>
                <Select
                  options={statusOptions}
                  placeholder="Trạng thái"
                  style={{ width: '150px' }}
                  allowClear
                />
              </Form.Item>
              <Form.Item name="dateRange" style={{ marginBottom: 0 }}>
                <RangePicker
                  style={{ width: '300px' }}
                  placeholder={['Từ ngày', 'Đến ngày']}
                />
              </Form.Item>
              <Form.Item style={{ marginBottom: 0 }}>
                <Space>
                  <Button 
                    type="primary" 
                    htmlType="submit" 
                    icon={<SearchOutlined />}
                  >
                    Tìm kiếm
                  </Button>
                  <Button onClick={handleReset}>Đặt lại</Button>
                </Space>
              </Form.Item>
            </Space>
          </Form>
        </div>
        <Table
          columns={columns}
          dataSource={depositHistory}
          rowKey="id"
          loading={loading}
          pagination={{
            ...tableParams.pagination,
            showSizeChanger: true,
            showTotal: (total) => `Tổng ${total} bản ghi`,
            position: ['bottomRight']
          }}
          onChange={handleTableChange}
          bordered={true}
          scroll={{
            x: 1200,
          }}
          style={{
            '.ant-table-thead > tr > th': {
              background: '#f7f9fc',
              fontWeight: 600
            },
            '.ant-table-tbody > tr:hover > td': {
              background: '#f5f8ff'
            },
            '.ant-tag': {
              minWidth: '80px',
              textAlign: 'center',
              fontWeight: 500
            }
          }}
        />
        <Drawer
          title={
            <Space>
              <PlusOutlined />
              <span>Tạo yêu cầu nạp tiền</span>
            </Space>
          }
          placement="right"
          onClose={() => setDrawerVisible(false)}
          open={drawerVisible}
          width={520}
          bodyStyle={{ paddingBottom: 80 }}
        >
          <Form
            form={form}
            layout="vertical"
            onFinish={(values) => {
              const numericAmount = parseFloat(parseNumber(values.amount));
              onFinish({ ...values, amount: numericAmount });
            }}
            style={{ maxWidth: '100%' }}
          >
            <Form.Item
              name="amount"
              label={<Text strong>Số tiền nạp</Text>}
              rules={[
                { required: true, message: 'Vui lòng nhập số tiền' },
                { 
                  validator: (_, value) => {
                    const numericValue = parseFloat(parseNumber(value || '0'));
                    if (numericValue < 10000) {
                      return Promise.reject('Số tiền tối thiểu là 10,000 VND');
                    }
                    return Promise.resolve();
                  }
                }
              ]}
            >
              <Input
                placeholder="Nhập số tiền (VND)"
                suffix="VND"
                size="large"
                onChange={handleAmountChange}
                style={{ borderRadius: '6px' }}
              />
            </Form.Item>
            <Form.Item
              name="note"
              label={<Text strong>Ghi chú</Text>}
            >
              <Input.TextArea
                placeholder="Nhập ghi chú (nếu có)"
                rows={4}
                style={{ borderRadius: '6px' }}
              />
            </Form.Item>
            <Form.Item style={{ marginBottom: 0 }}>
              <Button 
                type="primary" 
                htmlType="submit" 
                loading={loading}
                size="large"
                style={{
                  width: '100%',
                  height: '40px',
                  borderRadius: '6px',
                  marginTop: '12px'
                }}
              >
                Xác nhận nạp tiền
              </Button>
            </Form.Item>
          </Form>
        </Drawer>
      </div>
    </Page>
  );
};
export default Deposit; 